export default "__VITE_ASSET__hJNwLaTS__"